import { AvatarGenerator } from 'random-avatar-generator';
import { useENSName } from 'use-ens-name';

import { IRecievedChatProps } from 'interfaces/ChatTab/chatTab';

const UserRecievedText = ({ address, text, day }: IRecievedChatProps) => {
  const displayAddress = `${address?.substring(0, 10)} ...`;
  const ensName = useENSName(address);
  const date = new Date(day);
  const time = date.toLocaleString('en-US', {
    hour: 'numeric',
    hour12: true,
    minute: 'numeric',
  });
  const generator = new AvatarGenerator();
  const userAvatar = generator.generateRandomAvatar(address);

  return (
    <div className="flex mt-1 mb-4">
      <div className="">
        <div className="rounded-full w-6">
          <img src={userAvatar} alt="avatar" className="" />
        </div>
      </div>
      <div className="p-1  min-w-[200px] max-w-[280px]">
        <div className="border-t-[0px]  border-r-[#F2F2F7] float-left border-t-transparent border-b-[15px] border-b-transparent border-r-[20px]"></div>
        <div className="pr-2  rounded-r-lg rounded-bl-lg ml-3 bg-[#F2F2F7]">
          <div className="pl-2 font-semibold pt-2">
            {ensName || displayAddress}
          </div>
          <div className="">
            <p className="pl-2 break-words">{text}</p>
          </div>

          <div className="flex justify-end text-xs">{time}</div>
        </div>
      </div>
    </div>
  );
};

export default UserRecievedText;
